import { render, staticRenderFns } from "./emailSignature.vue?vue&type=template&id=fdcf804e&scoped=true"
import script from "./emailSignature.vue?vue&type=script&lang=js"
export * from "./emailSignature.vue?vue&type=script&lang=js"
import style0 from "./emailSignature.vue?vue&type=style&index=0&id=fdcf804e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf804e",
  null
  
)

export default component.exports